"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var container = function container(_ref) {
  var style = _ref.style,
      cloudimgURL = _ref.cloudimgURL;
  return _objectSpread({
    position: 'relative'
  }, style, {
    backgroundImage: "url(".concat(cloudimgURL, ")")
  });
};

var previewBgWrapper = function previewBgWrapper(_ref2) {
  var loaded = _ref2.loaded;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'inherit',
    transition: 'opacity 400ms ease 0ms',
    transform: 'translateZ(0)',
    overflow: 'hidden',
    opacity: loaded ? '0' : '1'
  };
};

var previewBg = function previewBg(_ref3) {
  var previewCloudimgURL = _ref3.previewCloudimgURL;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'inherit',
    backgroundImage: "url(".concat(previewCloudimgURL, ")"),
    transform: 'scale(1.1)',
    filter: "blur(10px)"
  };
};

var _default = {
  container: container,
  previewBgWrapper: previewBgWrapper,
  previewBg: previewBg
};
exports["default"] = _default;